import { createContext } from 'react';

import { ProblemWrapperContextType } from 'common.components/problem-wrapper/typings';

export const ProblemWrapperContext = createContext<ProblemWrapperContextType>({ wrapperRef: null });
